
import React from 'react'
import { Hero } from './Hero/Hero'
import { Card } from './Card/Card'

export const Main = () => {
  return (
    <>
        <Hero/>
        <Card/>
    </>
  )
}